import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { supabase } from "@/lib/supabase"

export default function AuthCallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // The Supabase client with detectSessionInUrl: true will automatically
    // pick up the code from the URL and exchange it for a session.
    // We just need to wait for the auth state to change, then redirect.
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(event => {
      if (event === "SIGNED_IN" || event === "TOKEN_REFRESHED") {
        navigate("/")
      }
    })

    // Also handle the case where the URL has a code parameter (PKCE flow)
    const url = new URL(window.location.href)
    const code = url.searchParams.get("code")
    if (code) {
      supabase.auth.exchangeCodeForSession(code).then(({ error }) => {
        if (error) {
          console.error("Error exchanging code for session:", error)
        }
        navigate("/")
      })
    }

    // Handle hash fragment (implicit flow fallback)
    if (window.location.hash && window.location.hash.includes("access_token")) {
      // detectSessionInUrl will handle this automatically
      // Just wait a moment for it to process
      setTimeout(() => {
        navigate("/")
      }, 1000)
    }

    return () => subscription.unsubscribe()
  }, [navigate])

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-600 border-t-transparent mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400">Completing sign in...</p>
      </div>
    </div>
  )
}
